module.exports = __webpack_public_path__ + "static/media/entertain-brylcreem.3ad2eb00.vtt";